module.exports = __webpack_public_path__ + "img/icon_version_baby.0c444722.png";